/**
 * PDP Reviews analytics: adds data-element-id and data-description to Yotpo-injected
 * review elements (Write a review, Show all reviews, Read more) for Tealium/analytics.
 */
(function() {
  const ATTR_MARK = 'data-pdp-reviews-analytics-done';
  const ELEMENT_ID = 'Prod_Reviews';

  const SELECTORS = [
    { desc: 'WriteReview', texts: ['write a review', 'write review'] },
    { desc: 'ShowAllReviews', texts: ['show all reviews', 'show all review'] },
    { desc: 'ReadMore', texts: ['read more', 'read more'] }
  ];

  /**
   * Returns true if element's visible text (trimmed, lowercased) matches any of the given texts.
   * @param {Element} el - DOM element (button or link).
   * @param {string[]} texts - Possible button/link texts (lowercase).
   * @returns {boolean}
   */
  function textMatches(el, texts) {
    const raw = (el.textContent || '').trim().toLowerCase();
    return texts.some((t) => raw === t || raw.replace(/\s+/g, ' ').indexOf(t) !== -1);
  }

  /**
   * Applies analytics attributes to a single element if it matches and not already marked.
   * @param {Element} el - Button or link element.
   * @param {string} description - data-description value.
   * @returns {boolean} True if attributes were applied.
   */
  function tagElement(el, description) {
    if (!el || el.getAttribute(ATTR_MARK)) return false;
    el.setAttribute('data-element-id', ELEMENT_ID);
    el.setAttribute('data-description', description);
    el.setAttribute(ATTR_MARK, '1');
    return true;
  }

  /**
   * Returns true if element is inside a reviews/Yotpo container (by class or id).
   * @param {Element} el - DOM element.
   * @returns {boolean}
   */
  function isInReviewsContext(el) {
    let node = el;
    while (node && node !== document.body) {
      const c = (node.className && node.className.toString()) || '';
      const id = (node.id && node.id.toString()) || '';
      const combined = (c + ' ' + id).toLowerCase();
      if (combined.indexOf('yotpo') !== -1 || combined.indexOf('review') !== -1) return true;
      node = node.parentElement;
    }
    return false;
  }

  /**
   * Scans the document for review CTAs and "Read more" links and tags them.
   * "Read more" is only tagged when inside a reviews/Yotpo context.
   * @returns {number} Number of elements newly tagged.
   */
  function scanAndTag() {
    let tagged = 0;
    const candidates = document.querySelectorAll('a, button, [role="button"]');
    candidates.forEach((el) => {
      if (el.getAttribute(ATTR_MARK)) return;
      for (const { desc, texts } of SELECTORS) {
        if (!textMatches(el, texts)) continue;
        if (desc === 'ReadMore' && !isInReviewsContext(el)) continue;
        if (tagElement(el, desc)) tagged += 1;
        break;
      }
    });
    return tagged;
  }

  /**
   * Run scanner once now and then on an interval until Yotpo has rendered or max attempts reached.
   */
  function run() {
    scanAndTag();
    let attempts = 0;
    const maxAttempts = 40; // ~20s at 500ms
    const interval = setInterval(() => {
      attempts += 1;
      scanAndTag();
      if (attempts >= maxAttempts) clearInterval(interval);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-scan when new content is added (e.g. Yotpo iframe, modal, or dynamic markup)
  const observer = new MutationObserver(() => {
    scanAndTag();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
